import { AppBar,Toolbar,Box,Typography, Button } from '@mui/material'
import React from 'react'

import { Link } from 'react-router-dom'
const Navigation = () => {
  return (
    <div>
    <AppBar elevation={0}>
               <Toolbar style={{background:"white",color:"black"}} >
                    <Box display='flex' flexGrow={1}>
                        <Typography>TIE</Typography>
                    </Box>

                    <Link to="/" style={{textDecoration:"none",color:"inherit"}}><Button variant='outlined' style={{borderColor:"#4D4D4D", color:"black"}} sx={{mx:2}}>Home</Button></Link>
                    <Link to="/Samples" style={{textDecoration:"none",color:"inherit"}}><Button variant='outlined' style={{borderColor:"#4D4D4D", color:"black"}} sx={{mx:2}}>Some Samples</Button></Link>

               </Toolbar>
           </AppBar>
    </div>
  )
}

export default Navigation